import { render } from "./MortgageProviderSelection.vue?vue&type=template&id=5cfdc78a&scoped=true"
import script from "./MortgageProviderSelection.vue?vue&type=script&lang=js"
export * from "./MortgageProviderSelection.vue?vue&type=script&lang=js"

import "./MortgageProviderSelection.vue?vue&type=style&index=0&id=5cfdc78a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfdc78a"]])

export default __exports__